var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"btn"},[_c('span',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changLange('C')}}},[_vm._v("繁")])]),_vm._v(" |\n    "),_c('span',[_c('a',{attrs:{"id":"eng","href":"javascript:;"},on:{"click":function($event){return _vm.changLange('E')}}},[_vm._v("ENG")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }